import PublicEnv from 'shared/utils/public-env';

const isBackofficeHosted = typeof window !== 'undefined' && /^\/ecomm(?:\/|$)/.test(window.location.pathname);

const AdminPublicEnv = {
  ...PublicEnv,
  adminBasePath: isBackofficeHosted ? '/ecomm' : undefined,
  graphqlUri: isBackofficeHosted ? '/api/ecom_admin/graphql' : PublicEnv.graphqlUri,
  isBackofficeHosted,
  useGetForHashedQueries: !isBackofficeHosted,
};

export default AdminPublicEnv;
